// extracted by mini-css-extract-plugin
export var standaloneTable = "_d7-0";
export var standaloneTableWithBodyFill = "_d7-1";
export var withExtraHeader = "_d7-2";